import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row lockHeader shinseisyoHeader" }
const _hoisted_2 = { class: "subheader col-md-6" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-dark fw-400 l-h-n"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-info fw-400 l-h-n"
}
const _hoisted_6 = {
  key: 2,
  class: "badge badge-success fw-400 l-h-n"
}
const _hoisted_7 = {
  key: 3,
  class: "badge badge-danger fw-400 l-h-n"
}
const _hoisted_8 = {
  class: "subheader-block ml-auto demo col-md-6",
  style: {"text-align":"right"}
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_15 = { class: "d-flex flex-start w-100" }
const _hoisted_16 = { class: "d-flex flex-fill" }
const _hoisted_17 = { class: "flex-fill" }
const _hoisted_18 = { class: "m-0" }
const _hoisted_19 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_20 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_21 = {
  key: 3,
  class: "alert alert-primary"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-xl-12" }
const _hoisted_24 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_25 = { class: "panel-container show" }
const _hoisted_26 = { class: "panel-content contents" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-5 contCnt" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-5 contCnt" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-5 contCnt" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-5 contCnt" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-5 contCnt" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-5 contCnt" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-5 contCnt" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-5 contCnt" }
const _hoisted_45 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_46 = { class: "col-md-5 contCnt" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-5 contCnt" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-5 contCnt" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-md-5 contCnt" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-5 contCnt" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-12 contCnt" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-5 contCnt" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-12 contCnt" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-5 contCnt" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md contCnt" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-5 contCnt" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-5 contCnt" }
const _hoisted_76 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_77 = { class: "row bdrTop" }
const _hoisted_78 = { class: "col-md-5 contCnt" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-md contCnt" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-md-5 contCnt" }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-md-5 contCnt" }
const _hoisted_86 = ["value"]
const _hoisted_87 = { class: "col-md-5 contCnt" }
const _hoisted_88 = ["value"]
const _hoisted_89 = { class: "row bdrTop" }
const _hoisted_90 = { class: "col-md-5 contCnt" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-md contCnt" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-md-5 contCnt" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-md-5 contCnt" }
const _hoisted_98 = ["value"]
const _hoisted_99 = { class: "col-md-5 contCnt" }
const _hoisted_100 = ["value"]
const _hoisted_101 = { class: "row bdrTop" }
const _hoisted_102 = { class: "col-md-5 contCnt" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = { class: "col-md contCnt" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-md-5 contCnt" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-md-5 contCnt" }
const _hoisted_110 = ["value"]
const _hoisted_111 = { class: "col-md-5 contCnt" }
const _hoisted_112 = ["value"]
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-md-5 contCnt" }
const _hoisted_115 = { class: "row" }
const _hoisted_116 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_117 = { class: "text-success fw-500" }
const _hoisted_118 = { class: "modal-footer" }
const _hoisted_119 = { class: "modal-footer" }
const _hoisted_120 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_CurrencyInput = _resolveComponent("Mo_CurrencyInput")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _cache[27] || (_cache[27] = _createTextVNode(" 稟議書 ")),
          (_ctx.delegate.request.c_request_status == 4)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_4, "取下"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 1)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "申請中"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 3)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_6, "承認済"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 2)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_7, "差戻"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.delegate.request.c_request_status != 2 && _ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl()))
            }, _cache[28] || (_cache[28] = [
              _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
              _createTextVNode("Excel出力 ")
            ]), 8, _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
            }, _cache[29] || (_cache[29] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_10))
          : _createCommentVNode("", true),
        (
            _ctx.isEditMode &&
            (_ctx.isAdmin || _ctx.isMine) &&
            _ctx.delegate.request.c_request_status != 4
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disableConf()))
            }, _cache[30] || (_cache[30] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("取下 ")
            ]), 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isEditMode && _ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.delConf()))
            }, _cache[31] || (_cache[31] = [
              _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
              _createTextVNode("削除 ")
            ]), 8, _hoisted_12))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/shinseisyolist')))
        }, _cache[32] || (_cache[32] = [
          _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
          _createTextVNode("戻る ")
        ]), 8, _hoisted_13)
      ])
    ]),
    _cache[89] || (_cache[89] = _createElementVNode("div", { class: "lockHeaderSpacer" }, "　", -1)),
    (_ctx.fmShowConf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
              _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                _createElementVNode("i", { class: "fal fa-info-circle" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "h5" }, "あなたが承認者です", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("p", null, [
                  _createTextVNode(" この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 稟議書では承認・差戻時にコメントを設定できます。 ")
                ], -1)),
                _createElementVNode("p", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, _cache[33] || (_cache[33] = [
                    _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
                    _createTextVNode("承認 ")
                  ])),
                  _cache[35] || (_cache[35] = _createElementVNode("span", { style: {"width":"20px"} }, " 　", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger waves-effect waves-themed",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.upd4Approval(false)))
                  }, _cache[34] || (_cache[34] = [
                    _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
                    _createTextVNode("差戻 ")
                  ]))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConfEx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[39] || (_cache[39] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-2d219caa><div class=\"mr-2 hidden-md-down\" data-v-2d219caa><span class=\"icon-stack icon-stack-lg\" data-v-2d219caa><i class=\"fal fa-info-circle\" data-v-2d219caa></i></span></div><div class=\"d-flex flex-fill\" data-v-2d219caa><div class=\"flex-fill\" data-v-2d219caa><span class=\"h5\" data-v-2d219caa>この申請書は承認依頼中です</span><p data-v-2d219caa> この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.fmShowSasimodosi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[40] || (_cache[40] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-2d219caa><div class=\"mr-2 hidden-md-down\" data-v-2d219caa><span class=\"icon-stack icon-stack-lg\" data-v-2d219caa><i class=\"fal fa-info-circle\" data-v-2d219caa></i></span></div><div class=\"d-flex flex-fill\" data-v-2d219caa><div class=\"flex-fill\" data-v-2d219caa><span class=\"h5\" data-v-2d219caa>この申請書は差し戻しされました</span><p data-v-2d219caa> この申請書は承認権者により差し戻しされています。差し戻し理由を確認の上、再度新しく申請書を作成してください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.fmShowTorisage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[41] || (_cache[41] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-2d219caa><div class=\"mr-2 hidden-md-down\" data-v-2d219caa><span class=\"icon-stack icon-stack-lg\" data-v-2d219caa><i class=\"fal fa-info-circle\" data-v-2d219caa></i></span></div><div class=\"d-flex flex-fill\" data-v-2d219caa><div class=\"flex-fill\" data-v-2d219caa><span class=\"h5\" data-v-2d219caa>この申請書は取り下げられました</span><p data-v-2d219caa> この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[79] || (_cache[79] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "申請時用"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_25, [
            _cache[78] || (_cache[78] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.request.c_request_id) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.request.c_request_id]
                      ])
                    ]),
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "管理名", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "xxxx案件でyyyy作業の為",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delegate.request.c_request_name) = $event))
                      }, null, 8, _hoisted_35), [
                        [_vModelText, _ctx.delegate.request.c_request_name]
                      ])
                    ]),
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請日時", -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.convDateTime(_ctx.delegate.request.c_request_datetime)
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_40)
                    ]),
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      (_ctx.isAdmin && !_ctx.isEditMode)
                        ? (_openBlock(), _createBlock(_component_vSelect, {
                            key: 0,
                            options: _ctx.getOpStaffs(),
                            label: "c_staff_name",
                            modelValue: _ctx.delegate.request.c_staff_id,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.request.c_staff_id) = $event)),
                            reduce: (label) => label.c_staff_id
                          }, null, 8, ["options", "modelValue", "reduce"]))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            name: "txtKouzaCd",
                            class: "form-control form-control-sm",
                            disabled: "",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.domApplicantName) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.domApplicantName]
                          ])
                    ]),
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "稟議書番号", -1)),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        disabled: "",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.delegate.c_request_aprv_id) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.c_request_aprv_id]
                      ])
                    ]),
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "決裁期限", -1)),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        maxlength: "8",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.domDeadline) = $event))
                      }, null, 8, _hoisted_53), [
                        [_vModelText, _ctx.domDeadline]
                      ])
                    ]),
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "E-mail（決裁結果連絡先）", -1)),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.domAddress) = $event))
                      }, null, 8, _hoisted_58), [
                        [_vModelText, _ctx.domAddress]
                      ]),
                      (_ctx.errors?.path === 'email')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "件名", -1)),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.domTitle) = $event))
                      }, null, 8, _hoisted_64), [
                        [_vModelText, _ctx.domTitle]
                      ]),
                      (_ctx.errors?.path === 'title')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "（内容・目的・理由）", -1)),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        rows: "5",
                        style: {"margin-bottom":"5px"},
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.domCont) = $event))
                      }, "                      ", 8, _hoisted_70), [
                        [_vModelText, _ctx.domCont]
                      ]),
                      (_ctx.errors?.path === 'reason')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "支払金額（税込）", -1)),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_Mo_CurrencyInput, {
                        name: "txtKouzaNumber",
                        modelValue: _ctx.domPrice,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.domPrice) = $event)),
                        class: "form-control form-control-sm",
                        "decimal-places": 0,
                        "allow-negative": false,
                        disabled: _ctx.isEditMode
                      }, null, 8, ["modelValue", "disabled"]),
                      (_ctx.errors?.path === 'Price')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "コメント", -1)),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(["form-control", { activeComment: !_ctx.isDisableComment1 }]),
                        rows: "5",
                        style: {"margin-bottom":"5px"},
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.domComment_1) = $event)),
                        disabled: _ctx.isDisableComment1
                      }, "                      ", 10, _hoisted_81), [
                        [_vModelText, _ctx.domComment_1]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _cache[68] || (_cache[68] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "第一承認", -1)),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(1),
                        disabled: ""
                      }, null, 8, _hoisted_86)
                    ]),
                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_1_approval,
                            _ctx.delegate.request.c_request_1_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_88)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_89, [
                _cache[69] || (_cache[69] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "コメント", -1)),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(["form-control", { activeComment: !_ctx.isDisableComment2 }]),
                        rows: "5",
                        style: {"margin-bottom":"5px"},
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.domComment_2) = $event)),
                        disabled: _ctx.isDisableComment2
                      }, "                      ", 10, _hoisted_93), [
                        [_vModelText, _ctx.domComment_2]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _cache[71] || (_cache[71] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "第二承認", -1)),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(2),
                        disabled: ""
                      }, null, 8, _hoisted_98)
                    ]),
                    _cache[70] || (_cache[70] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_2_approval,
                            _ctx.delegate.request.c_request_2_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_100)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_101, [
                _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "最終決済者（コメント）", -1)),
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(["form-control", { activeComment: !_ctx.isDisableComment3 }]),
                        rows: "5",
                        style: {"margin-bottom":"5px"},
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.domComment_3) = $event)),
                        disabled: _ctx.isDisableComment3
                      }, "                      ", 10, _hoisted_105), [
                        [_vModelText, _ctx.domComment_3]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_106, [
                _cache[74] || (_cache[74] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "最終承認", -1)),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        value: _ctx.getAuthoriser(3),
                        disabled: ""
                      }, null, 8, _hoisted_110)
                    ]),
                    _cache[73] || (_cache[73] = _createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1)),
                    _createElementVNode("div", _hoisted_111, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_3_approval,
                            _ctx.delegate.request.c_request_3_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_112)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _cache[77] || (_cache[77] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "決済結果", -1)),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-md-5 contCnt", { activeComment: !_ctx.isDisableResult }])
                    }, [
                      _createVNode(_component_vSelect, {
                        options: _ctx.optionsOp4,
                        modelValue: _ctx.delegate.c_request_aprv_result,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_request_aprv_result) = $event)),
                        reduce: (label) => label.code,
                        disabled: _ctx.isDisableResult
                      }, null, 8, ["options", "modelValue", "reduce", "disabled"]),
                      (_ctx.errors?.path === 'aprvResult')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _cache[75] || (_cache[75] = _createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)),
                    _cache[76] || (_cache[76] = _createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[21] || (_cache[21] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[80] || (_cache[80] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[81] || (_cache[81] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[82] || (_cache[82] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _cache[83] || (_cache[83] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => _cache[84] || (_cache[84] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("button", {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_disableConf" }, {
      title: _withCtx(() => [
        _cache[85] || (_cache[85] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDisableConf), 1)
      ]),
      body: _withCtx(() => _cache[86] || (_cache[86] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.disab())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeModal4disableConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[87] || (_cache[87] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[88] || (_cache[88] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}